import styled from 'styled-components'




// Text Styles

export const Title = styled.h1(props => ({
   fontSize:17,
   fontWeight:500,
   marginTop:0,
   marginBottom:0,
   lineHeight:"30px",
   color:"#5B5B5B",
   whiteSpace:"nowrap",
   "@media (max-width: 400px)": {
    whiteSpace:"normal",
  }
}));

export const Text = styled.div(props => ({
  color:props.color ? props.color : "rgba(91, 91, 91, 0.5)",
  display: props.inline ? "inline" : "block",
  fontSize: props.fontSize ? props.fontSize : 14,
  fontWeight:props.bold ? 500 : 400,
  lineHeight:"25px",
  marginBottom: props.marginBottom ? props.marginBottom : 0,
  marginTop: props.marginTop ? props.marginTop : 0,
  wordBreak: props.wordBreak,
  whiteSpace: props.whiteSpace ? "nowrap" : "normal",
  textAlign: props.align,
  "@media (max-width: 410px)": {
    fontSize:props.mobileFontSize ? props.mobileFontSize : 12,
  }
}));

export const Value = styled.div(props => ({
  color:props.color ? props.color : "#5B5B5B",
  fontSize: props.fontSize ? props.fontSize : 18,
  fontWeight:props.bold ? 500 : 400,
  textAlign: props.align,
  marginBottom: props.marginBottom ? props.marginBottom : 0,
  justifyContent: props.align === "right" ? "flex-end" : "flex-start",
  display:props.align === "right" ? "flex" : "block",
  alignItems:"center",
  "@media (max-width: 410px)": {
    fontSize:props.mobileFontSize ? props.mobileFontSize : 13,
  }
}));

export const ErrorMesage = styled.div(props => ({
  color:"#cc0000",
  marginTop:10,
  fontSize:10,
}));




// Button Styles

export const Button = styled.button(props => ({
  width: props.small ? props.width ? props.width : 100 : props.width ? props.width : 190,
  minWidth: props.small ? props.width ? props.width : 100 : props.width ? props.width : 190,
  height: props.small ? 30 : 54,
  background: props.color ? props.color : props.theme.colors.secondary,
  borderRadius:5,
  color:"#fff",
  display:"flex",
  border:"none",
  fontSize: props.small ? 14 : 16,
  fontWeight: props.small ? 400 : 500,
  justifyContent:"center",
  alignItems:"center",
  outline: props.disable ? "none": "default",
  cursor:props.disable ? "not-allowed" : "pointer",
  transition:"0.2s ease-in-out",
  marginTop:8,
  marginBottom:8,
  marginRight: props.marginRight ? props.marginRight : 0,
  ":hover":{
    opacity:props.disable ? 1 : 0.8,
  },
  "@media (max-width: 650px)": {
    height: props.small ? 30 : 38,
    fontSize: props.small ? 12 : 14,
  }
}));

export const ActionButton = styled.button(props => ({
  width:props.small ? "calc(100% + 60px)" : "100%",
  height:props.small ? 40 : 44,
  background:props.theme.colors.primary,
  color:"#fff",
  fontSize:props.small ? 14 : 16,
  fontWeight:400,
  display:"flex",
  border:"none",
  outline: "none",
  justifyContent:"center",
  alignItems:"center",
  cursor:"pointer",
  marginTop:props.small ? 20 : 0,
  marginBottom:props.small ? -20 : 0,
  marginLeft:props.small ? -30 : 0,
  marginRight:props.small ? -30 : 0,
  transition:"0.2s ease-in-out",
  ":hover":{
    opacity:0.8,
  }
}));






// Wrapper Styles

export const Jubotron = styled.div(props => ({
  position:"relative",
  background:props.background ? props.background : "#fff",
  padding:"20px 30px",
  borderRadius:10,
  margin:10,
  overflow:"hidden",
  boxShadow: "0px 8px 40px rgba(0, 0, 0, 0.03)",
  width: "calc("+props.width+" - 80px)",
  display: props.sameHeight ? "flex" : "block",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection:"column",
  "@media (max-width: 1300px)": {
    width: props.width==="33.3%" ? "calc(50% - 80px)" : "calc("+props.width+" - 80px)",
  },
  "@media (max-width: 1199px)": {
    width: props.width==="16.6%" ? "calc(33.3% - 80px)" : props.background && "calc(100% - 80px)",
  },
  "@media (max-width: 1000px)": {
    width:"calc(100% - 60px)",
  },
  "@media (max-width: 650px)": {
    padding:"20px 20px",
  },
}));

export const PageWrapper = styled.div(props => ({
  margin:"0 auto",
  marginTop:30,
  marginBottom:30,
  width:"calc(100% - 60px)",
  display: props.inline ? "flex" : "block",
  alignItems: props.sameHeight ? "stretch" : "flex-start",
  flexWrap:"wrap",
  "@media (max-width: 650px)": {
    width:"calc(100% - 20px)",
  }
}));

export const ValuesWrapper = styled.div(props => ({
  marginBottom: props.marginBottom ? props.marginBottom : 0,
  display:"flex",
  justifyContent: props.left ? "flex-start" : "space-between",
  alignItems:props.center ? "center" : "flex-start",
  "@media (max-width: 950px)": {
    flexDirection:props.noBreak ? "row" : "column",
    alignItems: (props.center&&props.noBreak) ? "center" : "flex-start",
  }
}));

export const TitleWrapper = styled.div(props => ({
  display:"flex",
  margin:"0 auto",
  width:"calc(100% - 20px)",
  justifyContent:"space-between",
  alignItems:"flex-end",
  "@media (max-width: 650px)": {
    flexDirection:"column",
    alignItems:"flex-start",
  }
}));

export const FormWrapper = styled.div(props => ({
  display:"flex",
  flexWrap:"wrap",
}));






// Other Styles

export const Line = styled.div(props => ({
   width:"100%",
   height:1,
   background: "rgba(0, 0, 0, 0.07)",
}));

export const Spacer = styled.div(props => ({
  height:20,
  width:20,
}));
